import { ElevesView, ElevesViewField } from '@teetsh/app/src/types/eleves';

export function orderFieldsInEleveViewFields(
  view: ElevesView,
  fieldsInOrder: string[],
): ElevesView {
  const viewFields = fieldsInOrder
    .map(f => view.fields.find(ff => ff.id === f))
    .filter(f => f);
  const remainingFields: ElevesViewField[] = view.fields.filter(
    f => !fieldsInOrder.includes(f.id),
  );
  return {
    ...view,
    fields: [...(viewFields as ElevesViewField[]), ...remainingFields],
  };
}
